import $ from 'jquery';
import Notices from './models/notices';
import NoticesView from './views/view';
import NoticesModalView from './views/modal';
import NoticesStickyView from './views/sticky';

let el;
let url;
let userData;
let cors;
let notices;
let notice;
let view;
let afterRender;

const corsOptions = {
  crossDomain: true,
  xhrFields: {
    withCredentials: true,
  },
};

const getSyncOptions = () => (cors === true ? corsOptions : {});

// eslint-disable-next-line arrow-parens
const notificationSelector = (id) => `.notifications[data-noticeid="${id}"]`;

const loadData = (callback) => {
  const options = Object.assign({}, getSyncOptions(), {
    success: (response) => {
      if (response.at(0) && response.at(0).attributes.response !== 'error') {
        callback();
      }
    },
    error: (error, response) => {
      throw new Error('mdnotice.loadData error:', response);
    },
  });
  notices.fetch(options);
};

const afterRenderCallback = () => {
  if (typeof afterRender === 'function') {
    afterRender();
  }
};

let closeCallbackPopup;
let closeCallback;

const render = () => {
  notice = notices.at(0);

  const id = notice && notice.get('id');
  if (!id) {
    afterRenderCallback();
    return;
  }

  if ($(notificationSelector(id)).length > 0) {
    afterRenderCallback();
    return;
  }
  const popup = parseInt(notice.get('popup'), 10) === 1;
  const View = popup ? NoticesModalView : NoticesView;
  view = new View({
    el,
    noticeData: notice.getNoticeData(userData),
    closeCallback: (data) => {
      const closeFn = popup ? closeCallbackPopup : closeCallback;
      return closeFn(data.noticeData, data.delete, data.callback);
    },
  });
  view.render();
  afterRenderCallback();
};

const deleteNoticeAction = (callback) => {
  const id = notice.get('id');
  const data = JSON.stringify({ id });

  const options = Object.assign({}, getSyncOptions(), {
    data,
    url: `${url}/${id}`,
    contentType: 'application/json',
    success: () => {
      $(notificationSelector(id)).remove();
      if (callback) {
        callback();
      } else {
        loadData(() => {
          render();
        });
      }
    },
    error: (error, response) => {
      throw new Error('mdnotice.deleteNoticeAction error', error, response);
    },
  });
  notice.destroy(options);
};

closeCallbackPopup = (noticeData, deleteNotice, callback) => {
  $('#notice-sticky').remove();
  view = new NoticesStickyView({
    el,
    noticeData,
    openCallback: () => {
      render();
    },
  });
  if (deleteNotice) {
    return deleteNoticeAction(callback);
  }
  view.render();
  return afterRenderCallback();
};

closeCallback = (noticeData, deleteNotice) => {
  if (deleteNotice) {
    return deleteNoticeAction();
  }
  return $(notificationSelector(noticeData.id)).remove();
};

const showNotices = () => {
  notices = new Notices([], { url });
  notices.url = url;
  loadData(() => {
    render();
  });
};

export default {
  init: (options) => {
    // eslint-disable-next-line object-curly-newline
    ({ el, url, userData, afterRender, cors } = options);
    showNotices();
  },
  getNotice: () => notice,
  getView: () => view,
  deleteNotice: () => {
    if (notice) {
      deleteNoticeAction();
    }
  },
  close: () => {
    if (view) {
      view.close();
    }
  },
};



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/